import React, { createContext, useContext, useState, useEffect } from "react";

const DoctorContext = createContext();

export const useDoctor = () => {
  const context = useContext(DoctorContext);
  if (!context) {
    throw new Error("useDoctor must be used within a DoctorProvider");
  }
  return context;
};

export const DoctorProvider = ({ children }) => {
  const [doctor, setDoctor] = useState(null);

  useEffect(() => {
    const storedDoctor = localStorage.getItem("doctorData");
    if (storedDoctor) {
      try {
        setDoctor(JSON.parse(storedDoctor));
      } catch (error) {
        localStorage.removeItem("doctorData");
      }
    }
  }, []);

  const value = {
    doctor,
    setDoctor,
  };

  return (
    <DoctorContext.Provider value={value}>{children}</DoctorContext.Provider>
  );
};

export default DoctorContext;
